import { Field, useFormikContext } from 'formik';
import React from 'react';
import { DateTimePickerUI, FormErrorUI, FormLabelUI, InputUI } from '../../../Interface';
import dayjs from 'dayjs';

const CalendarEventFields = () => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-4 mx-4 mb-5 gap-5">
      <div className="col-span-4">
        <Field
          name="title"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.title} />}
          InputLabelProps={{ shrink: values.title && values.title !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="date"
          name="startDate"
          component={DateTimePickerUI}
          value={dayjs(values.startDate)}
          fullWidth
          label={<FormLabelUI text="Kezdő dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.startDate} />}
          onChange={(date) => {
            setFieldValue('startDate', date).then(() => {
              validateField('startDate');
            });
          }}
          InputLabelProps={{ shrink: values.startDate !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-2">
        <Field
          type="date"
          name="endDate"
          component={DateTimePickerUI}
          value={dayjs(values.endDate)}
          fullWidth
          label={<FormLabelUI text="Befejező dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });
          }}
          InputLabelProps={{ shrink: values.endDate !== '' }}
        />
      </div>
    </div>
  );
};

export default CalendarEventFields;
